import { FC, type ChangeEvent } from "react";

import styled from "styled-components";
import styles from "./pieces-input.module.css";

import FixaSSRIcon from "../../../../shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import WarningTrianglePath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/WarningTrianglePath";
import { Trans } from "@coworker/locales";

const NumberInputContainer = styled.div`
  padding: 0 16px 24px 16px;
  border-bottom: 1px solid var(--grey200);
`;

const WarningIcon = styled(FixaSSRIcon)`
  color: var(--error);
  margin-right: 4px;
`;

const PiecesInput: FC<{
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
  hasError: boolean;
  message?: string;
  maxPieces: number;
  value: string;
  limitMessage?: string;
}> = ({
  onChange,
  hasError,
  message,
  maxPieces,
  value,
  limitMessage,
  onClick,
}) => {
  const hasNoMaxCapacity = maxPieces === 0;
  return (
    <NumberInputContainer onClick={onClick}>
      <div className={styles["number-input-wrapper"]}>
        {hasError && <WarningIcon paths={WarningTrianglePath} />}
        <input
          className={`${styles["number-input"]} ${
            hasError ? styles["error"] : ""
          }`}
          type="number"
          min={1}
          max={maxPieces}
          value={value}
          onChange={onChange}
        />
        <div className={styles["number-input-suffix"]}>
          <Trans>piecesString</Trans>
        </div>
      </div>
      {!!maxPieces && (
        <div className={styles["input-capacity"]}>
          {limitMessage && !hasError && <Trans>{limitMessage}</Trans>}
          <div className={styles["capacity-error-message"]}>
            <Trans>{message}</Trans>
          </div>
          <p>
            <span className={hasError ? styles["error"] : ""}>
              {value || 0}
            </span>{" "}
            / {maxPieces}
          </p>
        </div>
      )}
      {hasNoMaxCapacity && (
        <div className={styles["input-capacity"]}>
          <div className={styles["capacity-error-message"]}>
            <Trans>{message}</Trans>
          </div>
        </div>
      )}
    </NumberInputContainer>
  );
};

export default PiecesInput;
